import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import PurchaseCTA from 'ui-component-library/components/OnrampCTA/PurchaseCTA'
import { useCheckout, useProduct } from './ShoppingContext'

export type Props = {
  bodyText: string
  headlineText: string
  purchaseLinkText: string
  availabilityText: string
  valuePropText: string
  regionDropdown: {
    placeholderText: string
    options: { key: string; value: string }[]
  }
  product: {
    id: string
  }
}

function OnrampPurchaseCTAContainer(props: Props) {
  const [region, setRegion] = useState('')
  const { isLoading, product } = useProduct(props.product.id)

  const useQuery = () => {
    return new URLSearchParams(useLocation().search)
  }

  const query = useQuery()
  const referralCode = query.get('referral_code')

  const { onAddToCart, onUpdateCheckout, checkoutUrl, checkout } = useCheckout()

  useEffect(() => {
    if (product && checkout && checkout.lineItems.length === 0 && !isLoading) {
      onAddToCart([
        {
          variantId: product.variants[0].id,
          quantity: 1,
        },
      ])
    }
  }, [product, isLoading, checkout])

  function handleChangeRegion(region: string) {
    const attributes = [{ key: 'region', value: region }]

    if (referralCode) {
      attributes.push({ key: 'referral_code', value: referralCode })
    }
    setRegion(region)
    onUpdateCheckout(attributes)
  }

  function handleSubmit() {
    if (checkoutUrl) {
      window.location.href = checkoutUrl
    }
  }

  return (
    <PurchaseCTA
      {...props}
      region={region}
      onSubmit={handleSubmit}
      onChangeRegion={handleChangeRegion}
    />
  )
}

export default OnrampPurchaseCTAContainer
